module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-8.1420afce.jpg";